import { IndicationDefinition, IndicationGroup } from "@app/models/indication";
import { vennHealthConstants } from "./vennHealthConstants";

export class VennHealthHelpers {
    static getIndicationGroup(indication: IndicationDefinition): IndicationGroup {
        let indicationGroup;
        const allIndications = vennHealthConstants.allIndications;
        allIndications.forEach(group => {
            group.indications.forEach(ind => {
                if (ind.name === indication.name) {
                    indicationGroup = group;
                }
            });
        });
        return indicationGroup;
    }

    static getCurrentIndicationFromIndicationGroupJson(indication: IndicationDefinition, allIndications: IndicationGroup[]): IndicationDefinition {
        const currentIndicationGroup = VennHealthHelpers.getIndicationGroup(indication);
        const matchingGroupIndex = allIndications.findIndex(i => i.name === currentIndicationGroup.name);
        const matchingIndicationIndex = allIndications[matchingGroupIndex].indications.findIndex(i => i.name === indication.name);
        const currentIndication = allIndications[matchingGroupIndex].indications[matchingIndicationIndex];
        return currentIndication;
    }
}
